import { HttpClient, HttpParams } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { SaidaEstoque } from "../api/dto/saida-estoque";
import { DiaMes } from "../api/dto/datas/dia-mes";

@Injectable({providedIn: 'root'})
export class SaidaEstoqueService {
    constructor(private http: HttpClient) { }
    
    private url: string = UrlServidor.URL_BASE + 'saidas-estoque';

    listarPorEmpresaId(id?: number): Observable<SaidaEstoque[]> {
        return this.http.get<SaidaEstoque[]>(`${this.url}/empresa/${id}`);
    }

    listarPorEmpresaIdEPorData(id?: number, data?: Date): Observable<SaidaEstoque[]> {
        let params = new HttpParams();
        if(data)
            params = params.set('dataFiltro', data?.toISOString());

        return this.http.get<SaidaEstoque[]>(`${this.url}/empresa/${id}/filtrado`, {params});
    }

    listarDiasComSaidasPorEmpresaIdECompetencia(id?: number, competencia?: Date): Observable<DiaMes[]> {
        let params = new HttpParams();
        if(competencia)
            params = params.set('dataFiltro', competencia?.toISOString());

        return this.http.get<DiaMes[]>(`${this.url}/empresa/${id}/dias-saidas`, {params});
    }

    listarPorEmpresaIdEComanda(empresaId?: number, comandaId?: number): Observable<SaidaEstoque[]> {
        return this.http.get<SaidaEstoque[]>(`${this.url}/empresa/${empresaId}/comanda/${comandaId}`);
    }

    salvar(saidaEstoque?: SaidaEstoque): Observable<SaidaEstoque> {
        return this.http.post<SaidaEstoque>(this.url, saidaEstoque);
    }

    salvarSaidaJustificada(saidaEstoque?: SaidaEstoque): Observable<SaidaEstoque> {
        return this.http.post<SaidaEstoque>(this.url + '/justificada', saidaEstoque);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${id}`);
    }
}